module.exports = __webpack_public_path__ + "static/media/scope_work_img2.4bae8fa2.png";